import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AboutComponent } from './about/about.component';
import { GymComponent } from './gym/gym.component';
import { StableComponent } from './stable/stable.component';
import { PartysComponent } from './partys/partys.component';
import { JogaComponent } from './joga/joga.components';

const routes: Routes = [
  { path: '', redirectTo: '/about', pathMatch: 'full' },
  { path: 'about', component: AboutComponent, data: { state: 'about' } },
  { path: 'gym', component: GymComponent, data: { state: 'gym' } },
  { path: 'stable', component: StableComponent, data: { state: 'stable' } },
  { path: 'partys', component: PartysComponent, data: { state: 'partys' } },
  { path: 'joga', component:JogaComponent, data: { state: 'joga' } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
